import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import SingleComplexItem from './SingleComplexItem';
import { getPDF } from '../../../actions/menuActions';
import DeleteConfirmPopup from '../../Common/DeleteConfirmPopup';
import UserNavigationScreen from '../../UsersSubnavigation/UserNavigationScreen';
import CreateComplexModal from '../../MenuGenerator/Complex/CreateComplexModal';
import CreateComplexButton from './CreateComplexButton';
import {
  getComplexes,
  setIsShowDeletePopup,
  setIsShowDeletePopupCanceled,
  getComplexStatus,
  changeComplexStatus,
  changeComplexPauseStatus,
  toggleCreateComplexModal,
  changeComplexStartDate,
  deleteComplex,
} from '../../../actions/complex';
import { COMPLEX_PAUSE_ID } from '../../../constants/appConstants';

const ControlUsers = React.memo(
  ({
    toggleCreateComplexModal,
    user,
    complexes,
    isShowCreateComplexModal,
    getComplexes,
    getPDF,
    setIsShowDeletePopup,
    setIsShowDeletePopupCanceled,
    isShowDeletePopup,
    deletingComplexId,
    deletingComplexName,
    complexStatus,
    getComplexStatus,
    changeComplexStatus,
    changeComplexPauseStatus,
    changeComplexStartDate,
    deleteComplex,
  }) => {
    const [transformedComplexStatus, setTransformedComplexStatus] = React.useState([]);

    React.useEffect(() => {
      getComplexStatus();
    }, []);

    React.useEffect(() => {
      const transformComplexStatus = complexStatus.reduce((result, status) => {
        if (status.id !== COMPLEX_PAUSE_ID)
          result.push({
            key: status.id,
            text: status.status,
            value: status.id,
          });
        return result;
      }, []);

      setTransformedComplexStatus(transformComplexStatus);
    }, [complexStatus]);

    React.useEffect(() => {
      user && user.id && getComplexes(user.id);
    }, [user]);

    const onStatusChange = (complexId, data) => {
      changeComplexStatus(complexId, data.value, user.id);
    };

    const onChangeComplexPauseStatus = (complexId, data) => {
      changeComplexPauseStatus(complexId, data, user.id);
    };

    const onChangeComplexStartDate = (complexId, data) => {
      changeComplexStartDate(complexId, data, user.id);
    };

    const confirmDeleting = (event, id, name) => {
      event.stopPropagation();
      setIsShowDeletePopup(id, name);
    };
    return (
      <React.Fragment>
        <SelectContainer>
          <UserNavigationScreen isGetComplex title="Управление пользователем" />
        </SelectContainer>
        <CreateComplexButton />
        <CreateComplexModal
          isShow={isShowCreateComplexModal}
          onClose={toggleCreateComplexModal}
          userId={user.id}
          getComplexes={getComplexes}
        />
        {complexes &&
          complexes.map((complex) => (
            <React.Fragment>
              <SingleComplexItem
                key={complex.id}
                complex={complex}
                getPDF={getPDF}
                confirmDeleting={confirmDeleting}
                transformedComplexStatus={transformedComplexStatus}
                onStatusChange={onStatusChange}
                changeComplexPauseStatus={onChangeComplexPauseStatus}
                changeComplexStartDate={onChangeComplexStartDate}
              />
            </React.Fragment>
          ))}
        <DeleteConfirmPopup
          isOpen={isShowDeletePopup}
          title={deletingComplexName}
          onCancel={setIsShowDeletePopupCanceled}
          onDelete={() => deleteComplex(deletingComplexId, user.id)}
        />
      </React.Fragment>
    );
  },
);

const mapStateToProps = (state) => {
  const { user } = state.reducers;
  const { isShowRecommendedTemplate } = state.folders;
  const {
    complexes,
    isShowCreateComplexModal,
    isShowDeletePopup,
    deletingComplexId,
    deletingComplexName,
    complexStatus,
  } = state.complex;
  const { loader } = state.loader;
  return {
    user,
    isShowRecommendedTemplate,
    loader,
    isShowCreateComplexModal,
    complexes,
    isShowDeletePopup,
    deletingComplexId,
    deletingComplexName,
    complexStatus,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleCreateComplexModal: () => dispatch(toggleCreateComplexModal()),
    getComplexes: (userId) => dispatch(getComplexes(userId)),
    getComplexStatus: () => dispatch(getComplexStatus()),
    changeComplexStartDate: (complexId, newDate, userId) =>
      dispatch(changeComplexStartDate(complexId, newDate, userId)),
    changeComplexStatus: (complexId, newStatus, userId) =>
      dispatch(changeComplexStatus(complexId, newStatus, userId)),
    changeComplexPauseStatus: (complexId, newStatus, userId) =>
      dispatch(changeComplexPauseStatus(complexId, newStatus, userId)),
    deleteComplex: (menuId, userId) => {
      dispatch(deleteComplex(menuId, userId));
    },
    getPDF: (id) => {
      dispatch(getPDF(id));
    },
    setIsShowDeletePopupCanceled: () => {
      dispatch(setIsShowDeletePopupCanceled());
    },
    setIsShowDeletePopup: (id, name) => {
      dispatch(setIsShowDeletePopup(id, name));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ControlUsers);

const SelectContainer = styled.div`
  width: 70%;
  margin: 0 auto;
  @media (max-width: 992px) {
    width: 80%;
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Menus/ControlUsers/index.jsx